var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScoped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.38 9.187V6.375a1.406 1.406 0 00-1.405-1.406H8.725V3.562a1.406 1.406 0 00-1.407-1.406H3.1a1.406 1.406 0 00-1.407 1.406V20.25a1.594 1.594 0 003.128.41l2.205-10.456a1.406 1.406 0 011.35-1.017h13.005zm0 0a1.406 1.406 0 011.36 1.769l-2.062 9.843a1.406 1.406 0 01-1.36 1.045H3.284",
    stroke: "#707175",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.699 18.947a.805.805 0 01-1.162-.718v-5.426a.804.804 0 011.162-.719l5.426 2.714a.802.802 0 010 1.435l-5.426 2.714z",
    stroke: "#707175",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgScoped;